import React from 'react';
export default class InputText extends React.Component {
    render() {
        const { value, onChange, error, placeholder,
            autoFocus, label, comment, type, readOnly, id, min, max, className } = this.props;
        let _type = type ? type : "text";
        let _readOnly = readOnly ? readOnly : false;
        let _clasName = className ? className : 'form-control'

        return (
            <div className={label ? "form-group" : ""}>
                {label && <label htmlFor={id}>{label}</label>}
                <input
                    value={value}
                    onChange={(event) => { onChange && onChange(event) }}
                    className={_clasName}
                    placeholder={placeholder}
                    autoFocus={autoFocus}
                    type={_type}
                    readOnly={_readOnly}
                    id={id}
                    min={min}
                    max={max}
                />
                {comment && (<p>{comment}</p>)}
                {error && (<span className="d-block text-danger">{error}</span>)}
            </div>
        )
    }
}

